async function onDocumentReady() {
  const productQrCodeDataElement = document.querySelector('.cmp-product-qrcode-data')
  const productQrCodeDataSerialNumberElement = document.querySelector('.cmp-product-qrcode-data__serial-number-value')

  if (productQrCodeDataElement) {
    const endpointUrl = productQrCodeDataElement.dataset.endpointUrl
    const serialNumberNotFoundLabel = productQrCodeDataElement.dataset.serialNumberNotFoundLabel
    const errorMessage = productQrCodeDataElement.dataset.errorMessage
    const response = await fetch(endpointUrl)
    const responseData = await response.json()

    if (!response.ok) {
      console.error('Failed to fetch product QR code data:', response.statusText)

      if (productQrCodeDataSerialNumberElement) {
        productQrCodeDataSerialNumberElement.textContent = errorMessage
      }

      return
    }

    const [parameters, serialNumber] = responseData.columns

    const productQrCodeData = responseData.data
    const urlParameters = new URLSearchParams(window.location.search)
    const qrParameter = urlParameters.get('id')

    const match = qrParameter ? productQrCodeData.find((row) => row[parameters] === qrParameter) : null

    if (productQrCodeDataSerialNumberElement) {
      productQrCodeDataSerialNumberElement.textContent = match ? match[serialNumber] : serialNumberNotFoundLabel
    }
  }
}

if (document.readyState !== 'loading') {
  onDocumentReady()
} else {
  document.addEventListener('DOMContentLoaded', onDocumentReady)
}
